<template>
  <div class="row mb-1">
    <div id="topik-by-source" class="col-md-12 px-gap">
      <div class="card card-default shade">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="pull-left m-t-5 m-b-5">
                <h4 class="m-b-0">Grafik Topik Berdasarkan Source</h4>
                <p class="small hint-text">Grafik Topik Berdasarkan Source</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <loader-component v-if="is_loading" />
              <div v-else>
                <div
                  v-if="bar_data.x.length === 0"
                  class="alert alert-danger"
                  id="errorApiEl"
                  role="alert"
                  align="center"
                >
                  <strong>Mohon maaf, data tidak tersedia! </strong>
                  <br />
                  Tidak dapat menampilkan grafik dengan data kosong.
                </div>
                <bar-chart-component
                  v-else
                  :data="bar_data"
                  :reversed="reversed"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bar_chart_horizontal from "@/views/components/chart/bar_chart_horizontal.vue";
import loader_component from "@/views/components/loader.vue";

export default {
  name: "topik_by_source",
  props: {
    is_loading: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
    data: {
      type: Object,
      default: function() {
        return null;
      },
    },
    activeChannel: {
      type: Object,
      default: function() {
        return null;
      },
    },
    tipe: String,
  },
  components: {
    "bar-chart-component": bar_chart_horizontal,
    "loader-component": loader_component,
  },
  data() {
    return {
      bar_data: {
        x: [],
        y: [],
      },
      reversed: false,
      id_project: this.$store.getters.user.id_project,
    };
  },
  methods: {
    assembleBarData() {
      let color = [];
      let name = [];
      if (this.data && this.data.series && this.data.category) {
        this.bar_data.x = this.data.category;
        if (this.tipe == "medkon") {
          this.reversed = true;
          color = ["#e83e8c", "#6c757d", "#28a745"];
          name = ["Media TV", "Media Cetak", "Online News"];
          let temp = [];
          for (let i = 0; i < name.length; i++) {
            if (this.activeChannel) {
              if (i == 0 && this.activeChannel.formed.tv_status == 1) {
                temp.push({
                  color: color[i],
                  name: name[i],
                  data: this.data.series[i].data,
                });
              } else if (
                i == 1 &&
                this.activeChannel.formed.cetak_status == 1
              ) {
                temp.push({
                  color: color[i],
                  name: name[i],
                  data: this.data.series[i].data,
                });
              } else if (i == 2 && this.activeChannel.google.news_status == 1) {
                temp.push({
                  color: color[i],
                  name: name[i],
                  data: this.data.series[i].data,
                });
              }
              this.bar_data.y = temp;
            }
          }
        } else {
          this.reversed = false;
          color = [
            "#1da1f2",
            "#4267b2",
            "#e1306c",
            "#dc3545",
            "#000000",
            "#ffc107",
            "#3f3f3f",
          ];
          name = [
            "Twitter",
            "Facebook",
            "Instagram",
            "Youtube",
            "Forum",
            "Blog",
            "Review Aplikasi",
          ];
          let temp = [];
          for (let i = 0; i < name.length; i++) {
            if (this.activeChannel) {
              if (i == 0 && this.activeChannel.twitter.status == 1) {
                temp.push({
                  color: color[i],
                  name: name[i],
                  data: this.data.series[i].data,
                });
              } else if (i == 1 && this.activeChannel.facebook.status == 1) {
                temp.push({
                  color: color[i],
                  name: name[i],
                  data: this.data.series[i].data,
                });
              } else if (i == 2 && this.activeChannel.instagram.status == 1) {
                temp.push({
                  color: color[i],
                  name: name[i],
                  data: this.data.series[i].data,
                });
              } else if (i == 3 && this.activeChannel.youtube.status == 1) {
                temp.push({
                  color: color[i],
                  name: name[i],
                  data: this.data.series[i].data,
                });
              } else if (
                i == 4 &&
                this.activeChannel.google.forum_status == 1
              ) {
                temp.push({
                  color: color[i],
                  name: name[i],
                  data: this.data.series[i].data,
                });
              } else if (i == 5 && this.activeChannel.google.blog_status == 1) {
                temp.push({
                  color: color[i],
                  name: name[i],
                  data: this.data.series[i].data,
                });
              } else if (i == 6 && this.activeChannel.review.status == 1) {
                temp.push({
                  color: color[i],
                  name: name[i],
                  data: this.data.series[i].data,
                });
              }
              this.bar_data.y = temp;
            }
          }
        }
      }
    },
  },
  mounted() {
    if (this.data) {
      this.assembleBarData();
    }
  },
  watch: {
    data() {
      this.assembleBarData();
    },
  },
};
</script>
